// extracted by mini-css-extract-plugin
export default {"icon":"Review_icon__1a+we","content":"Review_content__LT8sb"};